import { render } from "./DropDownList.vue?vue&type=template&id=fa48fe2c"
import script from "./DropDownList.vue?vue&type=script&lang=js"
export * from "./DropDownList.vue?vue&type=script&lang=js"
script.render = render

export default script